import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.867 8.93a3.95 3.95 0 0 0 3.09-2.108L11.56 3.73a.733.733 0 0 1 1.36.521l-.502 1.935a2.28 2.28 0 0 0 1.932 2.836l1.63.198a.781.781 0 0 1-.01 1.553l-2.7.293a3.81 3.81 0 0 0-3.02 2.133l-1.462 3.037a.76.76 0 0 1-1.434-.468l.362-1.953a2.413 2.413 0 0 0-2.078-2.834l-1.62-.2a.78.78 0 0 1 .014-1.55z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }